export const EVENT_PAGE_LOAD = 'tracking/PAGE_LOAD';
export const EVENT_PAGE_VIEW = 'tracking/PAGE_VIEW';
export const EVENT_CLICK = 'tracking/CLICK';
export const EVENT_LOAD = 'tracking/LOAD';
export const EVENT_TOOLTIP = 'tracking/TOOLTIP';